import PropTypes from 'prop-types';
import React from "react";
import "./Card.css";

const Card = props => {
	const { children, className, ...rest } = props;
	return <div className={`Card ${className}`} {...rest}>{children}</div>;
};

Card.propTypes = {
	className: PropTypes.string,
	children: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.arrayOf(PropTypes.node)
	]).isRequired
}

Card.defaultProps = {
	className: ''
}

export default Card;
